(function () {
  function scrollSlider(button, direction) {
    var targetSelector = button.getAttribute('data-fw-target');
    var target = document.querySelector(targetSelector);
    if (!target) return;
    var firstCard = target.querySelector('.fw-product-card, .fw-card');
    var amount = firstCard ? (firstCard.getBoundingClientRect().width + 16) * 2 : Math.max(280, target.clientWidth * 0.72);
    target.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function normalizeContactLinks() {
    var contactTarget = '/#fw-contact';
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var text = (link.textContent || '').trim().toLowerCase();
      if (href === '/pages/contact' || href === '/pages/contact/' || href.indexOf('/pages/contact') === 0 || (text === 'contact' && href.indexOf('/pages/') === 0)) {
        link.setAttribute('href', contactTarget);
      }
    });

    if (window.location.pathname === '/pages/contact' || window.location.pathname === '/pages/contact/') {
      window.location.replace('/#fw-contact');
    }
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-fw-prev]');
    var next = event.target.closest('[data-fw-next]');
    if (prev) {
      event.preventDefault();
      scrollSlider(prev, -1);
    }
    if (next) {
      event.preventDefault();
      scrollSlider(next, 1);
    }
  });

  function initSliders() {
    document.querySelectorAll('.fw-slider').forEach(function (slider) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var moved = false;

      slider.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDown = true;
        moved = false;
        startX = event.clientX;
        scrollLeft = slider.scrollLeft;
        slider.classList.add('fw-is-dragging');
      });

      slider.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var walk = event.clientX - startX;
        if (Math.abs(walk) > 7) moved = true;
        slider.scrollLeft = scrollLeft - walk;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('fw-is-dragging');
        if (moved) {
          slider.dataset.fwJustDragged = 'true';
          window.setTimeout(function () {
            delete slider.dataset.fwJustDragged;
          }, 180);
        }
      }

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
        slider.addEventListener(type, endDrag);
      });

      slider.addEventListener('click', function (event) {
        if (slider.dataset.fwJustDragged === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    });
  }

  function initProductCardFallbackLinks() {
    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-fw-card-link]');
      if (!card) return;
      if (event.target.closest('button, input, select, textarea')) return;
      if (event.defaultPrevented) return;
      var slider = card.closest('.fw-slider');
      if (slider && slider.dataset.fwJustDragged === 'true') return;
      var link = event.target.closest('a[href]') || card.querySelector('a[href]');
      if (!link) return;
      if (!event.target.closest('a[href]')) {
        window.location.href = link.href;
      }
    });
  }

  function imageListFor(page) {
    var thumbs = Array.prototype.slice.call(page.querySelectorAll('[data-fw-thumb]'));
    var mainImage = page.querySelector('[data-fw-main-image]');
    var list = thumbs.map(function (thumb) {
      return {
        full: thumb.getAttribute('data-full-src'),
        zoom: thumb.getAttribute('data-zoom-src') || thumb.getAttribute('data-full-src'),
        alt: thumb.getAttribute('data-alt') || ''
      };
    }).filter(function (item) { return item.full; });

    if (!list.length && mainImage) {
      list.push({ full: mainImage.src, zoom: mainImage.getAttribute('data-zoom-src') || mainImage.src, alt: mainImage.alt || '' });
    }
    return list;
  }

  function setProductImage(page, index) {
    var images = imageListFor(page);
    if (!images.length) return;
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    page.dataset.fwCurrentIndex = String(index);

    var item = images[index];
    var mainImage = page.querySelector('[data-fw-main-image]');
    if (mainImage) {
      mainImage.src = item.full;
      mainImage.setAttribute('data-zoom-src', item.zoom || item.full);
      mainImage.alt = item.alt || '';
      mainImage.style.transformOrigin = 'center center';
      mainImage.classList.remove('is-hover-zoomed');
    }

    page.querySelectorAll('[data-fw-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', Number(thumb.getAttribute('data-fw-image-index') || 0) === index);
    });

    var lightbox = page.closest('.fw-product-template') ? page.closest('.fw-product-template').querySelector('[data-fw-lightbox]') : document.querySelector('[data-fw-lightbox]');
    if (lightbox && !lightbox.hidden) {
      var lightboxImage = lightbox.querySelector('[data-fw-lightbox-image]');
      if (lightboxImage) {
        lightboxImage.src = item.zoom || item.full;
        lightboxImage.alt = item.alt || '';
      }
    }
  }

  function openLightbox(page) {
    var images = imageListFor(page);
    if (!images.length) return;
    var index = Number(page.dataset.fwCurrentIndex || 0);
    var section = page.closest('.fw-product-template');
    var lightbox = section ? section.querySelector('[data-fw-lightbox]') : document.querySelector('[data-fw-lightbox]');
    if (!lightbox) return;
    var item = images[index] || images[0];
    var lightboxImage = lightbox.querySelector('[data-fw-lightbox-image]');
    if (lightboxImage) {
      lightboxImage.src = item.zoom || item.full;
      lightboxImage.alt = item.alt || '';
    }
    lightbox.dataset.fwCurrentIndex = String(index);
    lightbox.hidden = false;
    document.documentElement.classList.add('fw-lightbox-open');
  }

  function closeLightbox(lightbox) {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.documentElement.classList.remove('fw-lightbox-open');
  }

  function initProductGallery() {
    document.querySelectorAll('[data-fw-product-page]').forEach(function (page) {
      var mainButton = page.querySelector('[data-fw-open-zoom]');
      var mainImage = page.querySelector('[data-fw-main-image]');
      var thumbs = page.querySelectorAll('[data-fw-thumb]');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setProductImage(page, Number(thumb.getAttribute('data-fw-image-index') || 0));
        });
      });

      page.querySelectorAll('[data-fw-gallery-prev]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setProductImage(page, Number(page.dataset.fwCurrentIndex || 0) - 1);
        });
      });

      page.querySelectorAll('[data-fw-gallery-next]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setProductImage(page, Number(page.dataset.fwCurrentIndex || 0) + 1);
        });
      });

      if (mainButton) {
        mainButton.addEventListener('click', function () { openLightbox(page); });
      }

      if (mainButton && mainImage && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        mainButton.addEventListener('mousemove', function (event) {
          var rect = mainButton.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          mainImage.style.transformOrigin = x + '% ' + y + '%';
          mainImage.classList.add('is-hover-zoomed');
        });
        mainButton.addEventListener('mouseleave', function () {
          mainImage.style.transformOrigin = 'center center';
          mainImage.classList.remove('is-hover-zoomed');
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.matches('[data-fw-close-zoom]') || event.target.matches('[data-fw-lightbox]')) {
        closeLightbox(event.target.closest('[data-fw-lightbox]') || event.target);
      }

      var lightboxPrev = event.target.closest('[data-fw-lightbox-prev]');
      var lightboxNext = event.target.closest('[data-fw-lightbox-next]');
      if (lightboxPrev || lightboxNext) {
        var section = event.target.closest('.fw-product-template');
        var page = section ? section.querySelector('[data-fw-product-page]') : document.querySelector('[data-fw-product-page]');
        if (!page) return;
        setProductImage(page, Number(page.dataset.fwCurrentIndex || 0) + (lightboxNext ? 1 : -1));
      }
    });

    document.addEventListener('keydown', function (event) {
      var open = document.querySelector('[data-fw-lightbox]:not([hidden])');
      if (!open) return;
      var section = open.closest('.fw-product-template');
      var page = section ? section.querySelector('[data-fw-product-page]') : document.querySelector('[data-fw-product-page]');
      if (event.key === 'Escape') closeLightbox(open);
      if (page && event.key === 'ArrowLeft') setProductImage(page, Number(page.dataset.fwCurrentIndex || 0) - 1);
      if (page && event.key === 'ArrowRight') setProductImage(page, Number(page.dataset.fwCurrentIndex || 0) + 1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    normalizeContactLinks();
    initSliders();
    initProductCardFallbackLinks();
    initProductGallery();
  });
})();

(function () {
  function initHeroRotators() {
    document.querySelectorAll('[data-fw-hero-rotator]').forEach(function (rotator) {
      var slides = Array.prototype.slice.call(rotator.querySelectorAll('[data-fw-hero-slide]'));
      var dots = Array.prototype.slice.call(rotator.querySelectorAll('[data-fw-hero-dot]'));
      var prev = rotator.querySelector('[data-fw-hero-prev]');
      var next = rotator.querySelector('[data-fw-hero-next]');
      if (slides.length <= 1) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      var current = 0;
      var interval = Number(rotator.getAttribute('data-fw-interval') || 5000);
      var timer = null;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-current', i === current ? 'true' : 'false');
        });
      }

      function start() {
        stop();
        timer = window.setInterval(function () { show(current + 1); }, interval);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      if (prev) prev.addEventListener('click', function (event) { event.preventDefault(); show(current - 1); start(); });
      if (next) next.addEventListener('click', function (event) { event.preventDefault(); show(current + 1); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          show(Number(dot.getAttribute('data-fw-hero-dot') || 0));
          start();
        });
      });

      rotator.addEventListener('mouseenter', stop);
      rotator.addEventListener('mouseleave', start);
      rotator.addEventListener('focusin', stop);
      rotator.addEventListener('focusout', start);

      show(0);
      start();
    });
  }

  document.addEventListener('DOMContentLoaded', initHeroRotators);
})();
